var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcTiktok(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.8222 13.1333C24.0629 12.2661 23.6443 11.1527 23.6444 10H20.2111V23.7778C20.1852 24.5235 19.8706 25.2301 19.3337 25.7483C18.7968 26.2666 18.0796 26.556 17.3333 26.5556C15.7556 26.5556 14.4444 25.2667 14.4444 23.6667C14.4444 21.7556 16.2889 20.3222 18.1889 20.9111V17.4C14.3556 16.8889 11 19.8667 11 23.6667C11 27.3667 14.0667 30 17.3222 30C20.8111 30 23.6444 27.1667 23.6444 23.6667V16.6778C25.0367 17.6776 26.7082 18.2141 28.4222 18.2111V14.7778C28.4222 14.7778 26.3333 14.8778 24.8222 13.1333Z",
    fill: "#2E3192"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcTiktok);
export default __webpack_public_path__ + "static/media/ic_tiktok.01babe3f90008d88e9e127ec748bfb9a.svg";
export { ForwardRef as ReactComponent };